<!-- <div class="accountbg"></div> -->
<div class="accountbg" style="background: radial-gradient(circle at top, #0A3A6A 0%, #002347 60%) !important;"></div>
<div class="box-loading-login" id="box-loading-login">
  <div class="spinner-border text-warning" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div>
  <div class="wrapper-page" style="margin-left: auto;margin-top: 190px;">
    <div class="card card-pages shadow-none">
      <div class="card-body">
        <!-- <div class="text-center m-t-0 m-b-15">
          <a href="/" class="logo logo-admin">
            <h4 class="bold text-primary">{{nameApp}}</h4>
          </a>
        </div> -->
        <div class="w-100" style="margin-bottom: -15px;">
          <figure class="text-center">
            <img class="w-90" src="/img/sisgestour.png" alt="Sisgestour">
          </figure>
        </div>

        <form *ngIf="step === 'login'" class="form-horizontal m-t-0">
          <div class="form-group">
            <div class="col-12">
              <label>Correo electrónico</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                </div>
                <input class="form-control" type="email" [(ngModel)]="email" name="email" placeholder="Email" required>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-12">
              <label>Contraseña</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-lock"></i></span>
                </div>
                <input class="form-control" type="password" [(ngModel)]="password" name="password"
                  placeholder="Password" required>
              </div>
            </div>
          </div>
          <div class="form-group text-center m-t-20">
            <div class="col-12">
              <button class="btn btn-primary btn-block btn-lg waves-effect waves-light" type="submit" (click)="login()">
                INICIAR SESIÓN <i class="fas fa-sign-in-alt m-l-3"></i>
              </button>
            </div>
          </div>
        </form>

        <form *ngIf="step === 'otp'" class="form-horizontal m-t-0 animated fadeIn">
          <div class="text-center m-b-15">
            <p class="bold f-s-17">Verificación de 2 pasos.</p>
            <p class="text-muted">Se ha enviado un código al correo principal de empresa <strong class="text-primary">{{ maskEmail(emailCompany) }}</strong>. Ingréselo para continuar.</p>
          </div>
          <div class="form-group">
            <div class="col-12">
              <label>Código de Verificación</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-key"></i></span>
                </div>
                <input class="form-control" type="text" [(ngModel)]="otpCode" name="otpCode" placeholder="000000"
                  maxlength="6" required
                  style="letter-spacing: 8px; font-weight: bold; text-align: center; font-size: 1.2rem;">
              </div>
            </div>
          </div>
          <div class="form-group text-center m-t-20">
            <div class="col-12">
              <button class="btn btn-warning btn-block btn-lg waves-effect waves-light" style="height: 40px;" type="submit"
                (click)="verifyOtp()">
                VERIFICAR <i class="fas fa-check-circle m-l-3"></i>
              </button>
            </div>
          </div>
          <div class="text-center">
            <a href="javascript:void(0)" (click)="step = 'login'" class="text-muted m-b-10">
              <i class="fas fa-chevron-left"></i> Volver al login
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- <div class="accountbg"></div>
<div class="box-loading-login" id="box-loading-login">
  <div class="spinner-border text-warning" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<div>
  <div class="wrapper-page">
    <div class="card card-pages shadow-none">
      <div class="card-body">
        <div class="text-center m-t-0 m-b-15">
          <a href="/" class="logo logo-admin">
            <h4 class="bold text-primary">{{nameApp}}</h4>
          </a>
        </div>
        <form action="/login/form" class="form-horizontal m-t-30" method="post">
          <div class="form-group">
            <div class="col-12">
              <label>Correo electrónico</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fas fa-envelope"></i>
                  </span>
                </div>
                <input class="form-control" type="email" [(ngModel)]="email" name="email" placeholder="Email"
                  required="required">
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-12">
              <label>Contraseña</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fas fa-lock"></i>
                  </span>
                </div>
                <input class="form-control" type="password" [(ngModel)]="password" name="password" placeholder="Password"
                  required="required">
              </div>
            </div>
          </div>
          <div class="form-group text-center m-t-20">
            <div class="col-12">
              <button class="btn btn-primary btn-block btn-lg waves-effect waves-light" type="submit" (click)="login()">
                INICIAR SESIÓN <i class="fas fa-sign-in-alt m-l-3"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  
  </div>
</div>
 -->
